<template>
  <div class="confirm">
    <div
      class="confirm__canvas_faces"
      v-if="faces && faces.length"
    >

      <three-scene-engraving-confirm
        class="confirm__face"
        v-for="face in faces"
        :key="`canvas-face-scene-${face.face_id}`"
        :face="face"
        :ref="`sceneFace${face.face_id}`"
      />

    </div>
    <div class="confirm__canvas">

      <three-canvas
        ref="sceneMain"
        :isConfirm="true"
      />

    </div>
    <div class="confirm__actions">

      <div
        v-if="$route.query.order_cache"
        class="confirm__actions-left"
      >
        <div
          class="confirm__buttons"
          v-if="elements.length||landscaping.mainElement||barrier"
        >
          <button
            @click="onSaveAndContinue"
            class="confirm__button--continue"
          >Пересохранить и продолжить</button>
          <button
            @click="onSaveAndClose"
            class="confirm__button--continue confirm__button--close"
          >Пересохранить и закрыть</button>
        </div>
      </div>

      <div
        v-else
        class="confirm__actions-left"
      >
        <div class="confirm__buttons">
          <button
            class="confirm__button--back"
            @click="$router.go(-1)"
          >
            <img
              style="height: 18px"
              src="/images/design/nazad.svg"
            >
            <span>{{$t('client.confirm.button_back')}}</span>
          </button>
          <button
            v-if="elements.length||landscaping.mainElement||barrier"
            @click="onConfirm"
            class="confirm__button--continue"
          >{{$t('client.confirm.button_continue')}}</button>
        </div>
        <div class="confirm__title">{{$t('client.confirm.title')}}</div>
      </div>

      <div
        class="informer_confirm__total"
        v-if="settings.with_calc_price == 1"
      >
        <InformerApproximatePrice additionalClass="rb" />
        <div class="confirm__total">
          <span>{{ $toCurrency(total) }}</span>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import ThreeCanvas from "../../components/Client/ThreeCanvas.vue";
import ThreeSceneEngravingConfirm from "../../components/Client/ThreeSceneEngravingConfirm.vue";
export default {
  components: { ThreeCanvas, ThreeSceneEngravingConfirm },
  name: "Confirm",
  computed: {
    total() {
      return this.$store.state.clientOrder.total;
    },
    faces() {
      return this.$store.state.clientOrder.faces;
    },
    elements() {
      return this.$store.state.clientOrder.elements;
    },
    barrier() {
      return this.$store.state.clientOrder.barrier;
    },
    landscaping() {
      return this.$store.state.clientOrder.landscaping;
    },
    orderToSave() {
      return this.$store.getters["clientOrder/orderToSave"];
    },
    plot() {
      return this.$store.state.clientOrder.plot;
    },
    mockup() {
      return this.$store.state.clientOrder.mockup;
    },
    weight() {
      return this.$store.state.clientOrder.weight;
    },
    orderIdFromCache() {
      return this.$store.getters["clientOrder/orderIdFromCache"];
    },
    settings() {
      return this.$store.state.settings.settings;
    },
  },
  methods: {
    async onConfirm() {
      try {
        // Сначала проверяем, есть ли грани без finalImage
        const facesWithContent = this.faces.filter(
          face => (face.elements && face.elements.length > 0) || (face.texts && face.texts.length > 0)
        );
        const facesWithoutImage = facesWithContent.filter(face => !face.finalImage);
        
        // Если есть грани без изображений, пробуем сгенерировать
        if (facesWithoutImage.length > 0) {
          console.log(`Found ${facesWithoutImage.length} faces without images, generating...`);
          
          // Показываем индикатор загрузки
          this.$store.dispatch("notification/add", {
            type: "info",
            message: `Генерация макетов для ${facesWithoutImage.length} граней...`
          }, { root: true });
          
          // Ожидаем монтирования компонентов
          await this.$nextTick();
          await new Promise(resolve => setTimeout(resolve, 500));
          
          // Генерируем макеты
          const errors = await this.createMockups();
          
          // Проверяем снова после генерации
          await this.$nextTick();
          const stillWithoutImage = facesWithContent.filter(face => !face.finalImage);
          
          if (stillWithoutImage.length > 0) {
            const faceNames = stillWithoutImage.map(f => f.faceName || f.face_id).join(', ');
            
            // Если были критические ошибки, не переходим на /order
            if (errors && errors.length > 0) {
              const notification = {
                type: "error",
                message: `Не удалось сгенерировать макеты для ${stillWithoutImage.length} граней: ${faceNames}. Пожалуйста, обновите страницу и попробуйте еще раз.`
              };
              this.$store.dispatch("notification/add", notification, { root: true });
              console.error('Critical errors during mockup generation, not proceeding to order page');
              return;
            }
            
            // Если ошибок не было, но макеты не сгенерированы - предупреждение
            const notification = {
              type: "warning",
              message: `Не удалось сгенерировать макеты для ${stillWithoutImage.length} граней: ${faceNames}. Заказ будет создан без макетов этих граней.`
            };
            this.$store.dispatch("notification/add", notification, { root: true });
          } else {
            // Успешная генерация
            this.$store.dispatch("notification/add", {
              type: "success",
              message: "Макеты граней успешно сгенерированы"
            }, { root: true });
          }
        }
        
        // Генерируем макет главной сцены
        if (this.$refs.sceneMain) {
          const main = Array.isArray(this.$refs.sceneMain) 
            ? this.$refs.sceneMain[0] 
            : this.$refs.sceneMain;
          if (main && typeof main.createMockup === 'function') {
            console.log('Generating main scene mockup');
            try {
              await main.createMockup();
            } catch (error) {
              console.error('Error generating main scene mockup:', error);
              // Не блокируем переход, но логируем ошибку
            }
          }
        }
        
        // Финальная проверка перед переходом
        await this.$nextTick();
        console.log('All mockups generated, proceeding to order page');
        
        // Устанавливаем флаг, что мы переходим на /order со страницы /confirm
        // Это предотвратит редирект обратно на /confirm
        sessionStorage.setItem('justCameFromConfirm', 'true');
        
        this.$router.push({ name: "order" });
      } catch (error) {
        console.error("Error in onConfirm:", error);
        const notification = {
          type: "error",
          message: error.message || "Произошла критическая ошибка при генерации макетов. Пожалуйста, обновите страницу и попробуйте еще раз."
        };
        this.$store.dispatch("notification/add", notification, { root: true });
      }
    },

    async createMockups() {
      const errors = [];
      const warnings = [];
      
      // Находим грани без finalImage
      const facesNeedingMockup = this.faces.filter(face => {
        const hasContent = (face.elements && face.elements.length > 0) || (face.texts && face.texts.length > 0);
        return hasContent && !face.finalImage;
      });
      
      if (facesNeedingMockup.length === 0) {
        console.log('No faces need mockup generation');
        return null;
      }
      
      console.log(`Generating mockups for ${facesNeedingMockup.length} faces`);
      
      // Ожидаем следующего тика для монтирования компонентов
      await this.$nextTick();
      
      // Дополнительная задержка для гарантии монтирования
      await new Promise(resolve => setTimeout(resolve, 300));
      
      // Генерируем макеты для каждой грани
      for (const face of facesNeedingMockup) {
        const refName = `sceneFace${face.face_id}`;
        const faceName = face.faceName || face.face_id;
        
        try {
          const refValue = this.$refs[refName];
          
          if (!refValue) {
            console.warn(`Ref ${refName} not found`);
            errors.push({ face: faceName, error: 'Component ref not found' });
            continue;
          }
          
          let comp = null;
          
          if (Array.isArray(refValue)) {
            comp = refValue.find(c => c && typeof c.createMockup === 'function');
            if (!comp && refValue.length > 0) {
              comp = refValue[0];
            }
          } else {
            comp = refValue;
          }
          
          if (!comp) {
            console.warn(`Component not found for ${refName}`);
            errors.push({ face: faceName, error: 'Component not found' });
            continue;
          }
          
          // Проверяем готовность компонента
          if (typeof comp.ensureReady === 'function') {
            const isReady = await comp.ensureReady();
            if (!isReady) {
              console.warn(`Component ${refName} is not ready after waiting`);
              errors.push({ face: faceName, error: 'Component not ready' });
              continue;
            }
          }
          
          // Проверяем наличие метода createMockup
          if (typeof comp.createMockup !== 'function') {
            console.warn(`createMockup method not found for ${refName}`);
            errors.push({ face: faceName, error: 'createMockup method not found' });
            continue;
          }
          
          // Генерируем макет
          console.log(`Generating mockup for face ${face.face_id} (${faceName})`);
          await comp.createMockup();
          
          // Проверяем, что finalImage установлен
          await this.$nextTick();
          const updatedFace = this.faces.find(f => f.face_id === face.face_id);
          if (!updatedFace || !updatedFace.finalImage) {
            const errorMsg = `Макет для грани "${faceName}" не был сгенерирован`;
            console.warn(errorMsg);
            warnings.push({ face: faceName, error: errorMsg });
          } else {
            console.log(`Mockup generated successfully for face ${face.face_id} (${faceName})`);
          }
        } catch (error) {
          const errorMsg = `Ошибка при генерации макета для грани "${faceName}": ${error.message || String(error)}`;
          console.error(`Error creating mockup for ${refName}:`, error);
          errors.push({ face: faceName, error: errorMsg });
        }
      }
      
      // Показываем предупреждения
      if (warnings.length > 0) {
        warnings.forEach(warning => {
          this.$store.dispatch("notification/add", {
            type: "warning",
            message: warning.error
          }, { root: true });
        });
      }
      
      // Показываем ошибки
      if (errors.length > 0) {
        const errorMessages = errors.map(e => e.error).join('; ');
        this.$store.dispatch("notification/add", {
          type: "error",
          message: `Ошибки при генерации макетов: ${errorMessages}`
        }, { root: true });
      }
      
      // Возвращаем ошибки для обработки в onConfirm
      return errors.length > 0 ? errors : null;
    },

    async updateOrder() {
      try {
        await this.createMockups();

        let formDataPost = new FormData();

        formDataPost.append("_method", "PATCH");

        if (this.orderToSave) {
          formDataPost.append("order_cache", this.orderToSave);
        }

        if (this.plot !== null) {
          formDataPost.append("plot_id", this.plot.plot_id);
        }

        if (this.barrier !== null) {
          formDataPost.append("barrier[barrier_id]", this.barrier.element_id);
          formDataPost.append("barrier[kalitka]", this.barrier.kalitka);
          formDataPost.append("barrier[perimetr]", this.barrier.perimetr);
          formDataPost.append("barrier[sizes]", this.barrier.sizes);
          formDataPost.append("barrier[total]", this.barrier.total);
          formDataPost.append(
            "barrier[final_price_installation]",
            this.barrier.final_price_installation
          );
          //если выбрано положение калитки по центру
          let price_add_stolbik = 0;
          if (
            this.barrier.doorPosition &&
            this.barrier.doorPosition.wherePlace == "placeCenter" &&
            this.barrier.price_add_stolbik
          ) {
            price_add_stolbik = this.barrier.price_add_stolbik;
          }
          formDataPost.append("barrier[price_add_stolbik]", price_add_stolbik);
        }

        if (this.mockup) {
          formDataPost.append(`mockup`, this.mockup);
        }

        if (this.total !== null) {
          formDataPost.append("total", this.total);
        }

        if (this.weight !== null) {
          formDataPost.append("weight", this.weight);
        }

        if (this.elements.length) {
          for (const key in this.elements) {
            formDataPost.append(
              `elements[${key}][element_id]`,
              this.elements[key]["element_id"]
            );

            formDataPost.append(
              `elements[${key}][name]`,
              this.elements[key]["name"]
            );
            formDataPost.append(
              `elements[${key}][article]`,
              this.elements[key]["article"]
            );
            if (this.elements[key]["material"]) {
              formDataPost.append(
                `elements[${key}][element_material_id]`,
                this.elements[key]["material"]["material_id"]
              );
              formDataPost.append(
                `elements[${key}][material_name]`,
                this.elements[key]["material"]["name"]
              );
              formDataPost.append(
                `elements[${key}][material_coef]`,
                this.elements[key]["material"]["cost_coefficient"]
              );
            }
            if (this.elements[key]["size"]) {
              formDataPost.append(
                `elements[${key}][element_size_id]`,
                this.elements[key]["size"]["element_size_id"]
              );
              formDataPost.append(
                `elements[${key}][width]`,
                this.elements[key]["size"]["width"]
              );
              formDataPost.append(
                `elements[${key}][height]`,
                this.elements[key]["size"]["height"]
              );
              formDataPost.append(
                `elements[${key}][depth]`,
                this.elements[key]["size"]["length"]
              );
              formDataPost.append(
                `elements[${key}][size_coef]`,
                this.elements[key]["size"]["cost_coefficient"]
              );
              formDataPost.append(
                `elements[${key}][size_price]`,
                this.elements[key]["size"]["price"]
              );
              formDataPost.append(
                `elements[${key}][weight]`,
                this.elements[key]["size"]["weight"]
              );

              if (this.elements[key].polish) {
                formDataPost.append(
                  `elements[${key}][polish][id]`,
                  this.elements[key].polish.id
                );
                formDataPost.append(
                  `elements[${key}][polish][name]`,
                  this.elements[key].polish.name
                );
                formDataPost.append(
                  `elements[${key}][polish][description]`,
                  this.elements[key].polish.description
                );
                formDataPost.append(
                  `elements[${key}][polish][price]`,
                  this.elements[key].polish.price
                );
              }

              if (
                this.elements[key].services &&
                this.elements[key].services.length
              ) {
                for (const service of this.elements[key].services) {
                  formDataPost.append(
                    `elements[${key}][services][${service.id}][id]`,
                    service.id
                  );
                  formDataPost.append(
                    `elements[${key}][services][${service.id}][name]`,
                    service.name
                  );
                  formDataPost.append(
                    `elements[${key}][services][${service.id}][price]`,
                    service.price
                  );
                }
              }
            }

            formDataPost.append(
              `elements[${key}][type]`,
              this.elements[key]["type_name"]
            );
            if (
              this.elements[key]["total"] &&
              this.elements[key]["total"] != "undefined"
            ) {
              formDataPost.append(
                `elements[${key}][total]`,
                this.elements[key]["total"]
              );
            }
          }
        }

        if (this.landscaping) {
          for (const key in this.landscaping) {
            if (
              Object.hasOwnProperty.call(this.landscaping, key) &&
              this.landscaping[key] !== null &&
              Object.hasOwnProperty.call(this.landscaping[key], "element_id")
            ) {
              formDataPost.append(
                `landscaping[${key}][element_id]`,
                this.landscaping[key]["element_id"]
              );
              formDataPost.append(
                `landscaping[${key}][element_group_id]`,
                this.landscaping[key]["element_group_id"]
              );
              formDataPost.append(
                `landscaping[${key}][element_group_name]`,
                this.landscaping[key]["element_group_name"]
              );
              formDataPost.append(
                `landscaping[${key}][element_group_slug]`,
                this.landscaping[key]["element_group_slug"]
              );
              formDataPost.append(
                `landscaping[${key}][cost_preparation]`,
                this.landscaping[key]["cost_preparation"]
              );
              formDataPost.append(
                `landscaping[${key}][facing]`,
                this.landscaping[key]["facing"]
              );

              formDataPost.append(
                `landscaping[${key}][name]`,
                this.landscaping[key]["name"]
              );

              formDataPost.append(
                `landscaping[${key}][article]`,
                this.landscaping[key]["article"]
              );

              formDataPost.append(
                `landscaping[${key}][individual_size_material]`,
                this.landscaping[key]["individual_size_material"]
              );
              formDataPost.append(
                `landscaping[${key}][perimeter]`,
                this.landscaping[key]["perimeter"]
              );
              formDataPost.append(
                `landscaping[${key}][square]`,
                this.landscaping[key]["square"]
              );
              formDataPost.append(
                `landscaping[${key}][thickness]`,
                this.landscaping[key]["thickness"]
              );
              formDataPost.append(
                `landscaping[${key}][volume]`,
                this.landscaping[key]["volume"]
              );
              formDataPost.append(`landscaping[${key}][position]`, key);

              if (this.landscaping[key]["size"]) {
                formDataPost.append(
                  `landscaping[${key}][element_size_id]`,
                  this.landscaping[key]["size"]["element_size_id"]
                );
                formDataPost.append(
                  `landscaping[${key}][width]`,
                  this.landscaping[key]["size"]["width"]
                );
                formDataPost.append(
                  `landscaping[${key}][height]`,
                  this.landscaping[key]["size"]["height"]
                );
                formDataPost.append(
                  `landscaping[${key}][length]`,
                  this.landscaping[key]["size"]["length"]
                );
                formDataPost.append(
                  `landscaping[${key}][depth]`,
                  this.landscaping[key]["size"]["depth"]
                );

                formDataPost.append(
                  `landscaping[${key}][size_price]`,
                  this.landscaping[key]["size"]["price"]
                );
                formDataPost.append(
                  `landscaping[${key}][weight]`,
                  this.landscaping[key]["size"]["weight"]
                );
              }

              formDataPost.append(
                `landscaping[${key}][type]`,
                this.landscaping[key]["type_name"]
              );

              formDataPost.append(
                `landscaping[${key}][fact_sizes]`,
                this.landscaping[key]["fact_sizes"]
              );

              if (
                this.landscaping[key]["total"] &&
                this.landscaping[key]["total"] != "undefined"
              ) {
                formDataPost.append(
                  `landscaping[${key}][total]`,
                  this.landscaping[key]["total"]
                );
              }
            }
          }
        }

        if (this.faces.length) {
          for (const key in this.faces) {
            formDataPost.append(
              `faces[${key}][name]`,
              this.faces[key]["faceName"]
            );
            formDataPost.append(
              `faces[${key}][total]`,
              this.faces[key]["total"]
            );
            formDataPost.append(
              `faces[${key}][final_image]`,
              this.faces[key]["finalImage"]
            );
            if (
              this.faces[key].elements &&
              this.faces[key].elements.length > 0
            ) {
              for (const el of this.faces[key].elements) {
                formDataPost.append(
                  `faces[${key}][elements][${el.element_id}][element_id]`,
                  el.element_id
                );
                formDataPost.append(
                  `faces[${key}][elements][${el.element_id}][name]`,
                  el.name
                );
                formDataPost.append(
                  `faces[${key}][elements][${el.element_id}][article]`,
                  el.article
                );

                formDataPost.append(
                  `faces[${key}][elements][${el.element_id}][position_x]`,
                  el.position.x
                );
                formDataPost.append(
                  `faces[${key}][elements][${el.element_id}][position_y]`,
                  el.position.y
                );

                if (el.size) {
                  formDataPost.append(
                    `faces[${key}][elements][${el.element_id}][price]`,
                    el.size.price
                  );
                  formDataPost.append(
                    `faces[${key}][elements][${el.element_id}][width]`,
                    el.size.width
                  );
                  formDataPost.append(
                    `faces[${key}][elements][${el.element_id}][height]`,
                    el.size.height
                  );
                }
              }
            }
            if (this.faces[key].texts && this.faces[key].texts.length > 0) {
              for (const txtInd in this.faces[key].texts) {
                formDataPost.append(
                  `faces[${key}][texts][${txtInd}][text]`,
                  this.faces[key].texts[txtInd].text
                );
                formDataPost.append(
                  `faces[${key}][texts][${txtInd}][count]`,
                  this.faces[key].texts[txtInd].count
                );
                formDataPost.append(
                  `faces[${key}][texts][${txtInd}][position_x]`,
                  this.faces[key].texts[txtInd].position.x
                );
                formDataPost.append(
                  `faces[${key}][texts][${txtInd}][position_y]`,
                  this.faces[key].texts[txtInd].position.y
                );
                formDataPost.append(
                  `faces[${key}][texts][${txtInd}][price]`,
                  this.faces[key].texts[txtInd].price
                );
                formDataPost.append(
                  `faces[${key}][texts][${txtInd}][total]`,
                  this.faces[key].texts[txtInd].total
                );
                if (this.faces[key].texts[txtInd].font) {
                  formDataPost.append(
                    `faces[${key}][texts][${txtInd}][font_id]`,
                    this.faces[key].texts[txtInd].font.font_id
                  );
                  formDataPost.append(
                    `faces[${key}][texts][${txtInd}][font_family]`,
                    this.faces[key].texts[txtInd].font.name
                  );
                }
                if (this.faces[key].texts[txtInd].size) {
                  formDataPost.append(
                    `faces[${key}][texts][${txtInd}][font_size]`,
                    this.faces[key].texts[txtInd].size.height
                  );
                  formDataPost.append(
                    `faces[${key}][texts][${txtInd}][cost_coefficient]`,
                    this.faces[key].texts[txtInd].size.cost_coefficient
                  );
                }
              }
            }
          }
        }

        let url = `/api/admin/order-update/${this.orderIdFromCache}`;

        const res = await axios.post(url, formDataPost, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        const notification = {
          type: "success",
          message: "Заказ успешно сохранен",
        };
        this.$store.dispatch("notification/add", notification, {
          root: true,
        });

        this.$store.dispatch(
          "clientOrder/clearOrderEdit",
          this.orderIdFromCache
        );

        return res.data.data;
      } catch (error) {
        console.log(error);
        this.errors = error.response && error.response.data.errors;
        this.status = error.response && error.response.status;
        if (error.response) {
          const notification = {
            type: "error",
            message:
              error.response &&
              error.response.data &&
              error.response.data.message,
          };
          this.$store.dispatch("notification/add", notification, {
            root: true,
          });
        }
      }
    },

    async onSaveAndContinue() {
      try {
        const updatedOrder = await this.updateOrder();
        let route = { name: "index" };
        if (updatedOrder && updatedOrder.order_cache_id) {
          route = {
            ...route,
            query: { order_cache: updatedOrder.order_cache_id },
          };
        }
        this.$router.push(route);
      } catch (error) {
        console.log(error);
      }
    },
    async onSaveAndClose() {
      try {
        const updatedOrder = await this.updateOrder();
        let route = { name: "order_detail" };
        if (updatedOrder && updatedOrder.order_id) {
          route = {
            ...route,
            params: { order_id: updatedOrder.order_id },
          };
        }
        this.$router.push(route);
      } catch (error) {
        console.log(error);
      }
    },
    
    async retryMockupGeneration() {
      // Очищаем finalImage для всех граней с контентом
      const facesWithContent = this.faces.filter(
        face => (face.elements && face.elements.length > 0) || (face.texts && face.texts.length > 0)
      );
      
      facesWithContent.forEach(face => {
        this.$store.dispatch("clientOrder/setFaceFinalImage", {
          faceId: face.face_id,
          finalImage: null,
        });
      });
      
      // Ждем обновления
      await this.$nextTick();
      await new Promise(resolve => setTimeout(resolve, 500));
      
      // Генерируем заново
      return await this.createMockups();
    },
  },
};
</script>
<style scoped>
.confirm {
  display: grid;
  height: 100vh;
  grid-template-rows: auto max-content;
  position: relative;
  z-index: 1;
}

.confirm__canvas_faces {
  position: absolute;
  height: 100%;
  width: 100%;
  display: inline-flex;
  z-index: 0;
  left: 0;
  top: 0;
}

.confirm__canvas,
.confirm__actions {
  position: relative;
  z-index: 1;
}

.confirm__face {
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: 0;
  left: 0;
  top: 0;
}
.confirm__actions {
  background-color: #223644;
  color: #fff;
  display: flex;
  justify-content: space-between;
}
.confirm__actions-left {
  font-size: 14px;
  display: flex;
  align-items: center;
  column-gap: 20px;
}
.confirm__buttons {
  display: flex;
  align-items: center;
  padding: 15px 20px;
  column-gap: 15px;
}
.confirm__button--back {
  display: flex;
  align-items: center;
  column-gap: 10px;
  border: 2px solid #fff;
  border-radius: 4px;
  padding: 0 15px;
  height: 32px;
}
.confirm__button--continue {
  background-color: #10b981;
  padding: 0 20px;
  border-radius: 4px;
  height: 32px;
  display: flex;
  align-items: center;
}
.confirm__button--close {
  background-color: #3b82f6;
}

.confirm__total {
  padding: 15px 20px;
  background-color: #172935;
  font-size: 30px;
}

.confirm__canvas--wrapper {
  height: 100%;
}

.informer_confirm__total {
  display: flex;
  align-items: center;
  column-gap: 20px;
}

@media screen and (max-width: 1000px) {
  .confirm__actions {
    flex-direction: column;
  }
  .informer_confirm__total {
    padding: 10px;
    justify-content: center;
    flex-direction: column;
    background-color: #172935;
  }
  .confirm__total {
    padding: 0px;
  }
  .confirm__actions-left {
    flex-direction: column;
  }

  .confirm__actions-left .confirm__title {
    order: 1;
    padding-top: 5px;
  }

  .confirm__actions-left .confirm__buttons {
    order: 2;
    padding-top: 5px;
  }
}
</style>
